import { gql } from 'urql'

const QueryShowTenantMember = gql`
  query ($id: Int!) {
    showTenantMember(id: $id) {
      deviceRegistrations {
        id
        deviceToken
      }
      id
      email
      fullName
      phoneNumber
      jobTitle
      language
      timezone
      avatarVariants
      defaultColour
      jobTitle
      roles {
        id
        name
        code
      }
    }
  }
`

export default QueryShowTenantMember
